import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

// Initialize i18next
i18n
  .use(HttpBackend) // Loads translations from your backend/files
  .use(initReactI18next) // Passes i18n to react-i18next
  .init({
    fallbackLng: "en", // Default language if no match is found
    debug: false, // Enable debug mode
    interpolation: {
      escapeValue: false, // React already escapes values to prevent XSS
    },
    backend: {
      loadPath: `/localization/{{lng}}/{{ns}}.json?v=${new Date().getTime()}`, // Path to translation files
    },
  });

export default i18n;
